import ds from './DataSourceService'

const baseUrl = '/apartments'
const getAll = () => {
  return ds.apiClientThinkHome.get(baseUrl)
}
const getApartmentById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const getPoisForApartment = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/pois')
}

const addApartment = apartment => {
  return ds.apiClientThinkHome.post(baseUrl, apartment)
}

const updateApartment = apartment => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + apartment.id, apartment)
}

const deleteApartment = apartment => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + apartment)
}
const createDefaultPoi = apartment => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + apartment.id + '/create-default-poi',
    apartment
  )
}
export default {
  getApartmentById,
  getPoisForApartment,
  addApartment,
  updateApartment,
  deleteApartment,
  getAll,
  createDefaultPoi
}
